import { useEffect, useState } from 'react';
import { preloadImageSource } from '../_helpers/preload-image';
import { getFallbackImage } from '../_helpers/fallback-image';

import './SeriesItemImage.scss';

type ArticleImageProps = {
	imagePath: string;
	imageFallbackList: string[];
	saveUrl: string;
	hidden?: boolean;
};

const SeriesItemImage: React.FC<ArticleImageProps> = ({
	imagePath,
	imageFallbackList,
	saveUrl,
	hidden,
}) => {
	const [imageSource, setImageSource] = useState<string>('');

	useEffect(() => {
		if (!hidden && !imageSource) {
			setImageSource('');

			preloadImageSource(imagePath)
				.then(() => {
					setImageSource(imagePath);
				})
				.catch(() => {
					setImageSource(getFallbackImage(imageFallbackList, saveUrl));
				});
		}
	}, [imagePath, hidden]);

	return (
		<div className="item-image-container">
			<img data-final-url className="item-image" src={imageSource} alt="" />
		</div>
	);
};

export default SeriesItemImage;
